// eslint-disable-next-line no-restricted-syntax
import { useMutation } from '@apollo/client';
import { useState, useCallback, useEffect } from 'react';
import { UserForm } from '~/components/dialogs/edit-information';
import { UPDATE_USER } from '~/components/dialogs/edit-information/update-user/update-user.queries';
import { FetchFunnelPacketResponse } from '~/services/fetch-funnel-packet';
import { FETCH_FUNNEL_PACKET } from '~/services/fetch-funnel-packet/fetch-funnel-packet.queries';
import { UpdateUserInput } from '../../review-and-view-terms.wrapper';
import { EditUserComponent } from './edit-user.component';

interface EditUserDetailsProps {
  funnelPacket: FetchFunnelPacketResponse;
}

export const EditUserWrapper = (props: EditUserDetailsProps) => {
  const { funnelPacket } = props;
  const userId = funnelPacket?.user?.id!;
  const [initialFunnelPacket, setInitialFunnelPacket] =
    useState<FetchFunnelPacketResponse>(funnelPacket);
  const [editUserError, setEditUserError] = useState<Error | null>(null);
  const [closeEditForm, setCloseEditForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<UserForm>({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });
  const [mutate] = useMutation(UPDATE_USER, {
    refetchQueries: [{ query: FETCH_FUNNEL_PACKET, variables: { userId } }],
    onCompleted: data => {
      setInitialFunnelPacket({
        ...initialFunnelPacket,
        user: {
          ...initialFunnelPacket.user,
          ...data.updateUser,
        },
      });
      setCloseEditForm(!closeEditForm);
      setLoading(false);
    },
  });

  useEffect(() => {
    setUserDetails({
      firstName: initialFunnelPacket?.user?.firstName!,
      lastName: initialFunnelPacket?.user?.lastName!,
      email: initialFunnelPacket?.user?.email!,
      phone: initialFunnelPacket?.user?.phone!,
    });
  }, [initialFunnelPacket]);

  const handleUserSubmission = useCallback(
    async (data: UpdateUserInput) => {
      try {
        setLoading(true);
        await mutate({
          variables: {
            id: data.id,
            input: data.input,
          },
        });
      } catch (e) {
        setEditUserError(new Error('Something went wrong. Please try again.'));
      }
    },
    [mutate],
  );

  const resetEditUserError = () => {
    setEditUserError(null);
  };

  return (
    <EditUserComponent
      userId={userId}
      initialFormDetails={userDetails}
      closeEditForm={closeEditForm}
      handleUserSubmission={handleUserSubmission}
      resetEditUserError={resetEditUserError}
      error={editUserError}
      loading={loading}
    />
  );
};
